import { Routes } from './components/Routes';
import { DataFetchingClient, DataFetchingClientProvider } from 'data-fetching-client';
import { initializePortal, getLocaleInfo as getPortalsPlatformLocaleInfo } from 'portals-platform-lib';
import { PortalPlatformDataContext } from './contexts/PortalPlatformDataContext';
import { getDealPlanIdFromPath } from './utils/getDealPlanIdFromPath';
import { injectGoogleFonts } from './utils/injectGoogleFonts';
import { jsx as _jsx } from "react/jsx-runtime";
const client = new DataFetchingClient();

/**
 * Returns locale information for the portal.
 * This allows the Portal App to override the default locale with portal-specific settings.
 */
export function getLocaleInfo() {
  const dealPlanId = getDealPlanIdFromPath();
  return getPortalsPlatformLocaleInfo({
    client,
    objectId: dealPlanId !== null && dealPlanId !== void 0 ? dealPlanId : undefined
  });
}
export const prepareApp = async () => {
  // Initialize the portal and fetch theme/brand data
  let portalPlatformData = null;
  try {
    const dealPlanId = getDealPlanIdFromPath();
    const {
      portalData
    } = await initializePortal({
      client,
      objectId: dealPlanId !== null && dealPlanId !== void 0 ? dealPlanId : undefined
    });
    portalPlatformData = portalData;
    // On QA/prod the HubSpot script loader (injected via footerElements) handles
    // font loading. Locally the script loader doesn't run, so inject Google Fonts
    // directly to keep brand fonts working in local dev.
    if (process.env.NODE_ENV === 'development') {
      injectGoogleFonts(portalPlatformData);
    }
  } catch (error) {
    console.error('Failed to initialize portal. App may not function correctly:', error);
    // TODO: In Part 2, consider showing an error UI or failing gracefully
  }
  return {
    props: {
      dataFetchingClient: client,
      portalPlatformData
    }
  };
};
export function AppComponent({
  dataFetchingClient,
  portalPlatformData
}) {
  return /*#__PURE__*/_jsx(DataFetchingClientProvider, {
    client: dataFetchingClient,
    children: /*#__PURE__*/_jsx(PortalPlatformDataContext.Provider, {
      value: portalPlatformData,
      children: /*#__PURE__*/_jsx(Routes, {})
    })
  });
}